export const WorkExperienceData = {
	data: [
		{
			role: 'Video Editor',
			company: 'Tambua Women in Tech',
			startPeriod: 'May, 2022',
			endPeriod: 'Present',
			location: 'Nairobi, Kenya'
		},
		{
			role: 'Software Developer',
			company: 'Alternate Limited',
			startPeriod: 'December, 2018',
			endPeriod: 'Present',
			location: 'Nairobi, Kenya'
		},
		{
			role: 'Graphics Design Specialist',
			company: 'Mimidots',
			startPeriod: 'July, 2016',
			endPeriod: 'May, 2018',
			location: 'Kisii, Kenya'
		},
		{
			role: 'ICT Intern',
			company: 'Chief Magistrate Court',
			startPeriod: 'June, 2017',
			endPeriod: 'August, 2017',
			location: 'Eldoret, Kenya'
		}
	]
}
